import React, { CSSProperties, ReactNode, useState } from 'react';
import DialogBase from '../../../base/DialogBase/DialogBase';
import { DisciplineEnum, useGetUsersWithoutRoleQuery, useSetGlobalAdminMutation } from '../../../generated/graphql';
import { FormAutoComplete } from '../../form';
import styles from './NewAdminDialog.module.css';

type NewAdminDialogProps = {
    onClose: () => void,
    visible: boolean,
    style?: CSSProperties | undefined,
    children?: ReactNode | undefined,
};

const NewAdminDialog = (props: NewAdminDialogProps) => {
    const { style, visible, onClose } = props;
    const [searchUser, setSearchUser] = useState('');
    const [validationError, setValidationError] = useState('');
    const [setGlobalAdmin, setGlobalAdminResult] = useSetGlobalAdminMutation();
    const users = useGetUsersWithoutRoleQuery({
        variables: { contains: searchUser }
    });

    const handleSubmit = () => {
        const selectedUser = users.data?.UserList?.nodes?.find(u => u?.email === searchUser);
        if (!searchUser) {
            setValidationError('Please fill all of the following fields.');
            return;
        }
        if (!selectedUser) {
            setValidationError('Please select a valid email.');
            return;
        }
        setValidationError('');
        setGlobalAdmin({
            variables: { id: selectedUser.id, discipline: DisciplineEnum.None }
        })
            .then(() => { setSearchUser(''); onClose(); })
            .catch(() => {});
    };

    const handleClose = () => {
        setSearchUser('');
        setValidationError('');
        onClose();
    };

    return (
        <DialogBase
            title="New Global Admin"
            type="OkCancel"
            isLoading={setGlobalAdminResult.loading}
            visible={visible}
            onClose={handleClose}
            onSubmit={handleSubmit}
            validationError={validationError}
            className={styles.NewAdminDialog}
            style={style}
            data-testid="NewAdminDialog">
            <FormAutoComplete
                label="Email"
                name="email"
                value={searchUser}
                onChange={setSearchUser}
                options={(users.data?.UserList?.nodes?.map(u => u?.email) || []).filter((e): e is string => !!e)}
            />
        </DialogBase>
    );
};

export default NewAdminDialog;